module.exports = __webpack_public_path__ + "img/6.87c7de1f.jpg";